module.exports = __webpack_public_path__ + "img/plexus-5.d017ef42.png";